/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Recipient
 */
export interface Recipient {
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    referral_id: string;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    organization_id: string;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    facility_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    status: RecipientStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof Recipient
     */
    created_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof Recipient
     */
    updated_at: Date;
}


/**
 * @export
 */
export const RecipientStatusEnum = {
    Pending: 'pending',
    NeedsMoreInfo: 'needs_more_info',
    Accepted: 'accepted',
    Declined: 'declined',
    Confirmed: 'confirmed',
    Closed: 'closed'
} as const;
export type RecipientStatusEnum = typeof RecipientStatusEnum[keyof typeof RecipientStatusEnum];


/**
 * Check if a given object implements the Recipient interface.
 */
export function instanceOfRecipient(value: object): value is Recipient {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    return true;
}

export function RecipientFromJSON(json: any): Recipient {
    return RecipientFromJSONTyped(json, false);
}

export function RecipientFromJSONTyped(json: any, ignoreDiscriminator: boolean): Recipient {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
        'organization_id': json['organization_id'],
        'facility_id': json['facility_id'],
        'facility_name': json['facility_name'] == null ? undefined : json['facility_name'],
        'status': json['status'],
        'created_at': (new Date(json['created_at'])),
        'updated_at': (new Date(json['updated_at'])),
    };
}

export function RecipientToJSON(json: any): Recipient {
    return RecipientToJSONTyped(json, false);
}

export function RecipientToJSONTyped(value?: Recipient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
        'organization_id': value['organization_id'],
        'facility_id': value['facility_id'],
        'facility_name': value['facility_name'],
        'status': value['status'],
        'created_at': ((value['created_at']).toISOString()),
        'updated_at': ((value['updated_at']).toISOString()),
    };
}

